import axios from 'axios';

const API_BASE_URL = 'http://localhost:3001/api';

export type UserRole = 'merchant' | 'wave' | 'bank';

export interface UserRecord {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  privileges: string[];
  status: 'active' | 'inactive' | string;
  createdAt: string;
}

export interface UsersListResponse {
  data: UserRecord[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
    recordsPerPage: number;
  };
}

class UsersService {
  async list(params?: { page?: number; limit?: number; q?: string }): Promise<UsersListResponse> {
    const search = new URLSearchParams();
    if (params?.page) search.append('page', String(params.page));
    if (params?.limit) search.append('limit', String(params.limit));
    if (params?.q) search.append('q', params.q);
    const res = await axios.get(`${API_BASE_URL}/users?${search.toString()}`);
    return res.data;
  }

  /** Get user by exact email (for loading current user's privileges on login). */
  async getByEmail(email: string): Promise<UserRecord | null> {
    const res = await this.list({ q: email, limit: 20 });
    const match = res.data.find(u => u.email.toLowerCase() === email.toLowerCase());
    return match ?? null;
  }

  async create(payload: { email: string; name?: string; role: UserRole; privileges?: string[]; status?: string }): Promise<UserRecord> {
    const res = await axios.post(`${API_BASE_URL}/users`, payload);
    return res.data;
  }

  async update(id: string, payload: Partial<Pick<UserRecord, 'name' | 'role' | 'privileges' | 'status'>>): Promise<UserRecord> {
    const res = await axios.put(`${API_BASE_URL}/users/${id}`, payload);
    return res.data;
  }

  async remove(id: string): Promise<{ message: string }> {
    const res = await axios.delete(`${API_BASE_URL}/users/${id}`);
    return res.data;
  }
}

export default new UsersService();


